// extracted by mini-css-extract-plugin
export default {"popup":"InfoPopup_popup__NfZyt"};